// extracted by mini-css-extract-plugin
module.exports = {"className":"textActionM_className__8McJk"};